export const seismicityLevels = {
  ZERO: 0,
  FIRST: 1,
  SECOND: 2
};

export const buildingImportanceClasses = {
  FIRST: 1,
  SECOND: 2,
  THIRD: 3,
  FOURTH: 4
};

export const connectionTypes = {
  STRUCTURAL: 'structural',
  NON_STRUCTURAL: 'non-structural'
};

export const seismicPerformanceTypes = {
  NONE: 'none',
  C1: 'c1',
  C2: 'c2'
};

export const designOptions = {
  ELASTIC: 'elastic',
  CAPACITY: 'capacity',
  NONE: 'none',
  DUCTILITY_REQ: 'ductilityReq',
  ELASTIC_2: 'elastic_2'
};

export const displacementTypes = {
  CUSTOM: 'custom',
  ETA: 'eta'
};

export const seismicParams = {
  SEISMICITY_LEVEL: 'seismicityLevel',
  BUILDING_IMPORTANCE_CLASS: 'buildingImportanceClass',
  CONNECTIONS: 'connections',
  SEISMIC_PERFORMANCE: 'seismicPerformance',
  DESIGN_OPTION: 'designOption',
  DESIGN_AGAINST_NONDUCTILE: 'designAgainstNonductile',
  DESIGN_AGAINST_PREMATURE: 'designAgainstPremature',
  FILLED_HOLES: 'filledHoles',
  DISPLACEMENT: 'displacement',
  DISPLACEMENT_VALUE_TENSION: 'displacementValuesTension',
  DISPLACEMENT_VALUE_SHEAR: 'displacementValuesShear'
};


export class Seismic {

  constructor(
    seismicityLevel = seismicityLevels.ZERO,
    buildingImportanceClass = buildingImportanceClasses.SECOND,
    connections = connectionTypes.STRUCTURAL,
    seismicPerformance = seismicPerformanceTypes.C1,
    designOption = designOptions.NONE,
    filledHoles = false,
    displacement = displacementTypes.ETA,
    displacementValueTension = 0,
    displacementValueShear = 0
  ) {
    this[seismicParams.SEISMICITY_LEVEL] = seismicityLevel;
    this[seismicParams.BUILDING_IMPORTANCE_CLASS] = buildingImportanceClass;
    this[seismicParams.CONNECTIONS] = connections;
    this[seismicParams.SEISMIC_PERFORMANCE] = seismicPerformance;
    this[seismicParams.DESIGN_OPTION] = designOption;
    this[seismicParams.FILLED_HOLES] = filledHoles;
    this[seismicParams.DISPLACEMENT] = displacement;
    this[seismicParams.DISPLACEMENT_VALUES_TENSION] = displacementValueTension;
    this[seismicParams.DISPLACEMENT_VALUE_SHEAR] = displacementValueShear;
  }

}



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/DesignLoading/misc/seismic.class.js